import React from 'react';
import { SelectChangeEvent } from '@mui/material';
import DSMenuItem from '../../../../design-system/DSMenuItem';
import DSSelect from '../../../../design-system/DSSelect';
import { GreetingTone } from '../../../../api/gift';

interface ToneSelectorProps {
  value: GreetingTone | null | undefined;
  onChange: (tone: GreetingTone | undefined) => void;
}

const ToneSelector: React.FC<ToneSelectorProps> = ({ value, onChange }) => {
  return (
    <DSSelect
      fullWidth
      value={value ?? ''}
      onChange={(e: SelectChangeEvent<unknown>) => {
        const val = e.target.value as string;
        onChange(val ? (val as GreetingTone) : undefined);
      }}
      displayEmpty
      sx={{ mt: 1 }}
    >
      <DSMenuItem value="">
        <em>Select a tone (optional)</em>
      </DSMenuItem>
      {Object.values(GreetingTone).map((tone) => (
        <DSMenuItem key={tone} value={tone}>
          {tone}
        </DSMenuItem>
      ))}
    </DSSelect>
  );
};

export default ToneSelector;
